<template>
  <b-navbar toggleable="lg" type="light" variant="light">
    <b-navbar-brand>
      <Logo :logoProps="logo" />
    </b-navbar-brand>
    <b-navbar-brand
      v-if="$route.name != 'createProfile'"
      :href="userGroupId != 16 ? '/templates' :'/onboarding/dashboard'"
    >{{userGroupId != 16 ? $t('home') : $t('dashboard')}}</b-navbar-brand>

    <b-navbar-nav v-if="userGroupId != 16">
      <!-- <b-nav-item href="/stats">Stats</b-nav-item> -->
      <b-nav-item href="/templates">Templates</b-nav-item>
      <b-nav-item href="/clients">Clients</b-nav-item>

      <!-- <b-nav-item to="/my-questionnaires">Questionnaires</b-nav-item>
      <b-nav-item to="/my-training">Training</b-nav-item>
      <b-nav-item to="/my-certifications">Certifications</b-nav-item>-->
    </b-navbar-nav>

    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <!-- <b-nav-item-dropdown text="Applications" right>
        <b-dropdown-item href="#">Forms</b-dropdown-item>
        <b-dropdown-item href="#">Clients</b-dropdown-item>
        <b-dropdown-item href="#">Users</b-dropdown-item>
        <b-dropdown-item href="#">Diversity &amp; Inclusion</b-dropdown-item>
      </b-nav-item-dropdown>-->

      <!-- $store.state.form1.formDefaultLanguage ||  -->

      <b-nav-item-dropdown
        :text="defaultLanguageText(formDefaultLanguage)"
        class="capitalize"
        right
        v-if="userGroupId == 16"
      >
        <!-- v-if="userGroupId == 16" -->

        <!-- v-for="(lang, index) in $route.name == 'userform' ? $store.state.form1.formTranslations : globalLanguages" -->

        <b-dropdown-item
          v-for="(lang, index) in $store.state.form1.formTranslations"
          class="capitalize"
          :key="index"
          @click="onUpdateLanguage(lang)"
        >{{defaultLanguageText(lang)}}</b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown right>
        <!-- Using 'button-content' slot -->
        <template v-slot:button-content>
          <em>
            <font-awesome-icon icon="user" />
            {{nameToShow}}
          </em>
        </template>
        <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
        <b-dropdown-item @click="onLogout">{{$t('signOutBtnText')}}</b-dropdown-item>
        <b-dropdown-item to="profile">{{$t('updateProfile')}}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>
<script>
import { Helper } from "../../helpers";
import Layouts from "../../containers/layout";
import Logo from "../logo/logo.vue";
export default {
  name: "AppHeader",
  components: {
    Layouts,
    Logo
  },
  data() {
    return {
      logo: {
        width: "auto",
        height: "35px"
      },
      // globalLanguages: ["english", "spanish", "Chinese Simplified", "Chinese Traditional Taiwan", "arabic", "hebrew"],
      globalLanguages: ["english", "Chinese Simplified", "Japanese", "Spanish"],
      // globalLanguages: ["english"], // for sonova only
      // globalLanguages:[
      //   'english',
      //   'arabic',
      //   'chinese',
      //   'dutch',
      //   'french',
      //   'german',
      //   'hebrew',
      //   'indonesian',
      //   'japanese',
      //   'russian',
      //   'spanish',
      //   'swedish',
      //   'thai',
      // ],

      userGroupId: null,
      userFullName: null,
      userFirstName: null,
      userLastName: null,
      userEmail: null,
      nameToShow: null,
      formDefaultLanguage: "english"
    };
  },

  mounted() {
    this.userGroupId = localStorage.getItem("userGroupId");
    this.userFullName = localStorage.getItem("userFullname");
    this.userFirstName = localStorage.getItem("userFirstname");
    this.userLastname = localStorage.getItem("userLastname");
    this.userEmail = localStorage.getItem("userEmail");
    this.nameToShow =
      this.userFullName == "undefined" || "null"
        ? this.userFirstName == "null"
          ? ""
          : this.userFirstName + " " + this.userLastname == "null"
          ? ""
          : this.userLastname
        : this.userFullName;
    this.setLanguagesToStore();
  },

  methods: {
    setLanguagesToStore() {
      let languageInLocalStore =
        localStorage.getItem("formDefaultLanguage") || "english";
      if (languageInLocalStore == "chinese simplified") {
        this.$i18n.locale = "chinese";
      } else if (languageInLocalStore == "chinese traditional taiwan") {
        this.$i18n.locale = "chinesetr";
      } else {
        this.$i18n.locale = languageInLocalStore;
      }
      this.$store.state.form1.formDefaultLanguage = languageInLocalStore;
      this.$store.state.selectedLanguage = languageInLocalStore;
      this.formDefaultLanguage = languageInLocalStore;
    },

    defaultLanguageText(lang) {
      let ll = lang.toLowerCase();
      if (ll == "chinese simplified") {
        return this.$t("languages.chinese");
      } else if (ll == "chinese traditional taiwan") {
        return this.$t("languages.chinesetr");
      } else {
        // return this.$t('languages.'+lang)
        // console.log("llll", ll)
        return this.$i18n.availableLocales.includes(ll) ? this.$t('languages.'+ll) : ll;
      }
    },

    onUpdateLanguage(lang) {
      // // console.log("onUpdateLanguage", lang)
      let yy = lang.toLowerCase();
      if (yy == "chinese simplified") {
        lang = "chinese";
      }
      if (yy == "chinese traditional taiwan") {
        lang = "chinesetr";
      }
      // this.$store.state.isLoading = true;
      // ff ? ll : 'english' // for check inludes
      let ll = lang.toLowerCase();
      let ff = this.$i18n.availableLocales.includes(ll); // checking selected languages with saved messages
      this.$i18n.locale = ff ? ll : "english";
      this.$store.state.form1.formDefaultLanguage = yy;
      this.$store.state.selectedLanguage = yy;
      localStorage.setItem("formDefaultLanguage", yy);
      this.formDefaultLanguage = ff ? ll : "english";
      if (ll == "arabic" || ll == "hebrew") {
        this.$store.state.rightAlign = true;
      } else {
        this.$store.state.rightAlign = false;
      }
      //  setTimeout(() => {
      //   this.$store.state.isLoading = false;
      // }, 200);
    },

    onLogout() {
      localStorage.clear();
      // localStorage.removeItem("accessToken");
      // Helper.makeToast(
      //   this.$bvToast,
      //   "success",
      //   this.$t("toast.logoutSuccess"),
      //   this.$t("toast.title")
      // );
      //this.$router.replace("/login");
      if (process.env.VUE_APP_ENVIRONMENT == "development") {
        this.$router.replace("/login");
      } else if (process.env.VUE_APP_ENVIRONMENT == "production") {
        // console.log("url", process.env.VUE_APP_LOGIN_URL);
        window.location.href = process.env.VUE_APP_LOGIN_URL;
      }
    }
  }
};
</script>
<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>